import React, { FC } from 'react';
import manageMultiUser1 from '../../../assets/ManageMultiUser1.png';
import manageMultiUser2 from '../../../assets/ManageMultiUser2.png';
import manageMultiUser3 from '../../../assets/ManageMultiUser3.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpImage, HelpStep, HelpTitle } from './HelpElements';

const ManageUsersHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('manageUsersHelp');

    return (
        <>
            <HelpTitle>{t('manageUsersHelp_Title')}</HelpTitle>
            <HelpBody>{t('manageUsersHelp_description')}</HelpBody>
            <HelpStep step={1}>{t('manageUsersHelp_step1')}</HelpStep>
            <HelpStep step={2}>{t('manageUsersHelp_step2')}</HelpStep>
            <HelpStep step={3}>{t('manageUsersHelp_step3')}</HelpStep>
            <HelpImage size={'xlarge'} src={manageMultiUser1} />
            <HelpStep step={4}>{t('manageUsersHelp_step4')}</HelpStep>
            <HelpStep step={5}>{t('manageUsersHelp_step5')}</HelpStep>
            <HelpImage size={'medium'} src={manageMultiUser2} />
            <HelpStep step={6}>{t('manageUsersHelp_step6')}</HelpStep>
            <HelpStep step={7}>{t('manageUsersHelp_step7')}</HelpStep>
            <HelpStep step={8}>{t('manageUsersHelp_step8')}</HelpStep>
            <HelpImage size={'medium'} src={manageMultiUser3} />
        </>
    );
};

export { ManageUsersHelp };
